<!-- main Nav -->
<div class="navbar fixed-top navbar-expand-lg">

  <!-- 3M RSAM logo -->
  <div class="navbar-brand">
    <a href="#" title="Logo of {{ 'Header.navbar.logotexttip' | translate }}" tabindex="-1">
      <!-- <img src="assets/images/threemlogo.png" class="app-logo"> -->
      <img src="assets/images/logo30px.svg" class="app-logo" alt="Logo of Roadway Safety Asset Manager" />
    </a>
    <!-- <label class="pl-2 color-primary logo-txt"> {{'Header.navbar.logotext'|translate}}</label>{{'Header.navbar.logotext'|translate}} -->
  </div>

  <!-- hamburger button when screen too narrow for nav toolbar-->
  <button
    [ngClass]="{ collapsed1: isCollapsed === true }"
    class="navbar-toggler navbar-toggler-right"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
    (click)="isCollapsed = !isCollapsed"
    [attr.aria-expanded]="!isCollapsed"
    aria-controls="navbarSupportedContent"
    id="nav1"
  >
    <span> </span>
    <span> </span>
    <span> </span>
  </button>

  <nav class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="isCollapsed">
    <ul class="navbar-nav ml-auto">

      <!-- Select -->
      <li [ngClass]="{ 'i-active': activeTab === 'select' }" class="nav-container" *ngIf="currentUser.soultionTiers[0][0].asset_Selection">
        <a role="button" href="#" class="nav-new" (click)="optionClicked($event, 'select')" >
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-select" svgIcon="select" ></mat-icon>
            <div class="xsmall new-icon-text">{{ "Header.navitem.select" | translate }}
            </div>
          </div>
        </a>
      </li>

      <!-- Query Builder -->
      <li id="querybuilder" [ngClass]="{ 'i-active': activeTab === 'querybuilder' }" class="nav-container">
        <a role="button" href="#" class="nav-new" (click)="optionClicked($event, 'querybuilder')">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-query" svgIcon="pencil"></mat-icon>
            <div class="xsmall new-icon-text">{{ "Header.navitem.query" | translate }}</div>
          </div>
        </a>
      </li>

      <!-- Add -->
      <li [ngClass]="{ 'i-active': activeTab === 'add' }" class="nav-container" *ngIf="currentUser.rolePermissions.assetAdd && currentUser.selectedRegion && currentUser.selectedRegion.accessPrivilege === 'Data Editor'">
        <a role="button" href="#" class="nav-new" (click)="optionClicked($event, 'add')">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-add" svgIcon="add"></mat-icon>
            <div class="xsmall new-icon-text">{{ "Header.navitem.add" | translate }}</div>
          </div>
        </a>
      </li>

      <!-- Make (Sign Shop/Fab) -->
      <li id="makeViewer" [ngClass]="{ 'i-active': activeTab === 'makeViewer' }" class="nav-container" *ngIf="showMakeNav">
        <a role="button" href="#" class="nav-new" (click)="optionClicked($event, 'makeViewer')">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-select" svgIcon="make" ></mat-icon>
            <div class="xsmall new-icon-text">Make</div>
          </div>
        </a>
      </li>
      
      <!-- Tasks (My Maintenance) -->
      <li id="maintenanceViewer" [ngClass]="{ 'i-active': activeTab === 'maintenanceViewer' }" class="nav-container">
        <a role="button" id="tasks-new" href="#" class="nav-new"  aria-expanded="false" (click)="optionClicked($event, 'maintenanceViewer')">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-tasks" svgIcon="query"></mat-icon>
            <div class="xsmall new-icon-text">{{ "Header.navitem.mytasks" | translate }}</div>
          </div>
        </a>
      </li>

      <!-- Help -->
      <li [ngClass]="{ 'i-active': activeTab === 'help' }" class="nav-container">
        <a role="button" id="help" href="#" class="nav-new" data-toggle="collapse" data-target="#helpMenu" 
              (click)="optionClicked($event, 'help')">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-help" svgIcon="question"></mat-icon>
            <div class="xsmall new-icon-text">{{ "Header.navitem.help" | translate }}</div>
          </div>
        </a>
      </li>

      <!-- 3M Admin -->
      <li [ngClass]="{ 'i-active': activeTab === 'admin' }" id="3MAdminNav" class="nav-container" *ngIf="currentUser.rolePermissions.roleName === '3MAdmin'">
        <a href="#" class="nav-new" id="admin" (click)="optionClicked($event, 'admin')" data-toggle="modal"
              data-target="#nerModal" role="button" data-mainPageTabbing="no">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-3madmin" svgIcon="profile"></mat-icon>
            <div class="xsmall new-icon-text">{{ "Header.navitem.3madmin" | translate }}</div>
          </div>
        </a>
      </li>

      <!-- Settings (Customer Admin)-->
      <li [ngClass]="{ 'i-active': activeTab === 'settings' }"  id="adminNav" class="nav-container" *ngIf="currentUser.rolePermissions.adminAdvanced">
        <a id="adminLink" href="#" class="nav-new" data-toggle="modal" data-target="#settingModal" role="button"
              data-mainPageTabbing="no" (click)="optionClicked($event, 'settings')">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-tasks" id="setting-icon" svgIcon="profile"></mat-icon>
            <div class="xsmall new-icon-text" id="setting-icon-text">{{ "Header.navitem.settings" | translate }}</div>
            <span [ngClass]="{ 'notification-active': settingNotification }" class="notification" *ngIf="currentUser.usesExternalDataProvider && notificationCount > 0">{{ notificationCount }}</span>
          </div>
        </a>
      </li>

      <!-- More -->
      <li [ngClass]="{ 'i-active': activeTab === 'more' }" class="nav-container">
        <a role="button" id="more" href="#" class="nav-new" data-toggle="collapse" data-target="#moreMenu" 
              (click)="optionClicked($event, 'more')" title="Show additional toolbar"> <!-- (focus)="optionFocus($event, 'more')" title="Show additional toolbar" -->
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-more" svgIcon="more"></mat-icon>
            <div class="xsmall new-icon-text">{{ "Header.navitem.more" | translate }}</div>
          </div>
        </a>
      </li>

      <li class="divider-container">
        <div class="divider"></div>
      </li>

      <!-- Sign Out -->
      <li class="nav-container">
        <a role="button" id="signout" href="#" class="nav-new" (click)="logout()">
          <div class="nav-item-new">
            <mat-icon class="icon-new icon-new-logout" svgIcon="exit-door"></mat-icon>
            <div class="xsmall new-icon-text">Sign out</div>
          </div>
        </a>
      </li>
    </ul>
  </nav>
</div>

<!--Help menu-->
<div id="helpMenu" *ngIf="activeTab === 'help'" class="navSubmenu" role="navigation">
  <ul class="navbar-nav">
    <!-- help center -->
    <li class="text-center" *ngIf="jcc_functional && currentUser.soultionTiers[0][0].help_Center">
      <a role="button" href="#" class="nav-link" (click)="optionClicked($event, 'helpCenter')" 
            id="helpCenter" title="{{ 'Header.helpnavitem.helpcentre' | translate }}">
        <mat-icon class="icon-navSubmenu">help_center</mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.helpnavitem.helpcentre" | translate }}</div>
      </a>
    </li>
    <!-- help docs -->
    <li class="text-center">
      <a 
        [href]="ramhelp" 
        target="_blank" 
        class="nav-link" 
        data-forTab="yes" 
        (click)="optionClicked($event, 'helpDocs')" 
        id="helpDocs" title="{{ 'Header.helpnavitem.help' | translate }}"
      >
        <mat-icon class="icon-navSubmenu">help_outline</mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.helpnavitem.help" | translate }}</div>
      </a>
    </li>
    <!-- about -->
    <li class="text-center">
      <a role="button" href="#" class="nav-link" data-forTab="yes" (click)="optionClicked($event, 'about')" 
            id="helpAbout" title="{{ 'Header.helpnavitem.about' | translate }}">
        <mat-icon class="icon-navSubmenu">info</mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.helpnavitem.about" | translate }}</div>
      </a>
    </li>
  </ul>
</div>
<!--End of Help menu-->

<!--More menu-->
<div id="moreMenu" *ngIf="activeTab === 'more'" class="navSubmenu" role="navigation">
  <ul class="navbar-nav">
    <!-- regions -->
    <li class="text-center" *ngIf="currentUser.soultionTiers[0][0].active_Region_Selection">
      <a
        role="button"
        href="#"
        class="nav-link i-inactive"
        data-forTab="yes"
        (click)="optionClicked($event, 'filter')"
        id="filter"
        title="{{ 'Header.navitem.regions' | translate }}"
      >
        <mat-icon class="icon-new" svgIcon="map"></mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.navitem.regions" | translate }}</div>
      </a>
    </li>
    <!-- layers -->
    <li class="text-center">
      <a
        role="button"
        href="#"
        class="nav-link i-inactive"
        data-forTab="yes"
        (click)="optionClicked($event, 'layers')"
        id="layers"
        title="{{ 'Header.navitem.layers' | translate }}"
      >
        <mat-icon class="icon-new" svgIcon="layers"></mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.navitem.layers" | translate }}</div>
      </a>
    </li>
    <!-- search -->
    <li class="text-center">
      <a
        role="button"
        href="#"
        class="nav-link i-inactive"
        data-forTab="yes"
        (click)="optionClicked($event, 'search')"
        id="search"
        title="{{ 'Header.navitem.search' | translate }}"
      >
        <mat-icon class="icon-new" svgIcon="search"></mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.navitem.search" | translate }}</div>
      </a>
    </li>
    <!-- redline -->
    <li class="text-center">
      <a
        role="button"
        href="#"
        class="nav-link i-inactive"
        id="redline"
        data-forTab="yes"
        (click)="optionClicked($event, 'redline')"
        title="{{ 'Header.navitem.redline' | translate }}"
      >
        <mat-icon class="icon-new" svgIcon="redline"></mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.navitem.redline" | translate }}</div>
      </a>
    </li>
    <!-- measure -->
    <li class="text-center">
      <a
        role="button"
        href="#"
        class="nav-link i-inactive"
        id="measure"
        data-forTab="yes"
        (click)="optionClicked($event, 'measure')"
        title="{{ 'Header.navitem.measure' | translate }}"
      >  <!-- 
          data-toggle="collapse"
          data-target="#moreMenu"
        -->
        <mat-icon class="icon-new icon-new-logout" svgIcon="measure"></mat-icon>
        <div class="xsmall subnav-icon-text">{{ "Header.navitem.measure" | translate }}</div>
      </a>
    </li>
    <!-- snapshot -->
    <li class="text-center" *ngIf="currentUser.soultionTiers[0][0].solution_State_Snapshot">
      <a
        role="button"
        href="#"
        class="nav-link i-inactive"
        data-forTab="yes"
        (click)="capturescreen()"
        id="solutionSnapshot"
        title="{{ 'Header.navdrpdwn.screenshot' | translate }}"
      >  <!-- 
          data-toggle="collapse"
          data-target="#moreMenu"
        -->
        <mat-icon class="icon-new icon-new-logout" svgIcon="screen-shot"></mat-icon>
        <!--<div class="xsmall subnav-icon-text">{{ "Header.navdrpdwn.screenshot" | translate }}</div>-->
        <div class="xsmall subnav-icon-text">Screen</div>
      </a>
    </li>
    <!-- data editor settings -->
    <li
      *ngIf="(currentUser.rolePermissions.roleName == 'Admin' || currentUser.rolePermissions.roleName == 'DataCollector' || currentUser.rolePermissions.roleName == '3MAdmin') 
            && currentUser.soultionTiers[0][0].data_Collector_Settings"
      class="text-center navSubmenu-dataEditor"
    >
      <a
        role="button"
        href="#"
        class="nav-link i-inactive"
        data-forTab="yes"
        (click)="optionClicked($event, 'datacollectorSettings')"
        id="datacollectorSettings"
        title="{{ 'Header.navdrpdwn.datacollectorSettings' | translate }}"
      >  <!-- 
          data-toggle="collapse"
          data-target="#moreMenu"
        -->
        <mat-icon class="icon-new icon-new-logout" svgIcon="data-editor"></mat-icon>
        <!-- <div class="xsmall subnav-icon-text">{{ "Header.navdrpdwn.datacollectorSettings" | translate }}</div> -->
        <div class="xsmall subnav-icon-text">Data</div>
      </a>
    </li>
  </ul>
</div>
<!--End of More menu-->

<!-- Settings (aka Customer Admin) form -->
<!-- POSSIBLE SOLUTION <div *ngIf="auth.currentUserValue.serviceLyrInfo" class="modal fade" id="settingModal" tabindex="-1" role="dialog" aria-label="settingModalLabel" data-backdrop="false" aria-hidden="true" #appMovableArea></div> -->
<div class="modal fade" id="settingModal" tabindex="-1" role="dialog" aria-label="settingModalLabel" data-backdrop="false" aria-hidden="true" #appMovableArea>
  <div class="modal-dialog administrator-details" #DemoHandle role="document">
    <div class="modal-content settingmodal" cdkDrag cdkDragBoundary="#settingModal" ngResizable [rzHandles]="'e,w'">
<!-- modal-xl-->
      <app-configurable-header 
        cdkDragHandle 
        [headingText]="'Settings.maindiv.heading' | translate" 
        [variant]="'none'" 
        [iconOne]="'cross'" 
        [tooltipOne]="'Close'" 
        (actionOne)="closeAdmin()"
      > 
      </app-configurable-header>

      <section class="modal-body modalHeights show" id="administrationPopup">

        <mat-tab-group [selectedIndex]="0">

          <!-- Admin Reports-->
          <mat-tab *ngIf="currentUser.soultionTiers[0][0].solution_Administrator_Reports" label="{{ 'Settings.tabs.reports' | translate }}">
            <app-sms-reports [map]="map"></app-sms-reports>
          </mat-tab>

          <!-- Crew Management-->
          <mat-tab *ngIf="jcc_functional && currentUser.soultionTiers[0][0].crew_Management" label="{{ 'Settings.tabs.crewmanagement' | translate }}">
            <div style="min-height: 60vh; display: flex; align-items: center; justify-content: center">
              <button mat-button class="primary-button h7" data-dismiss="modal" (click)="optionClicked($event, 'crewmanagement'); closeAdmin()">
                {{ "Crewmanagement.crewmanagement.btn" | translate }}
              </button>
            </div>
          </mat-tab>

          <!-- Users -->
          <mat-tab *ngIf="currentUser.soultionTiers[0][0].user_Administration" title="{{ 'Settings.tabs.useradmin' | translate }}" label="{{ 'Settings.tabs.useradmin' | translate }}">
            <ng-template matTabContent>
              <app-sms-useradmin></app-sms-useradmin>
            </ng-template>
          </mat-tab>

          <!-- Advanced-->
          <mat-tab label="{{ 'Settings.tabs.advance' | translate }}">
            <!--<div class="card"> -->
              <div class="card-body">
                <ng-template matTabContent>
                  <mat-tab-group>

                    <!-- Crowdsourcing -->
                    <mat-tab *ngIf="jcc_functional && currentUser.soultionTiers[0][0].crowdsourcing_Installed_Asset_State" title="{{ 'Settings.tabs.crowdSource' | translate }}" label="{{ 'Settings.tabs.crowdSource' | translate }}">
                      <ng-template matTabContent>
                        <div class="sms-model-height">
                          <div class="card">
                            <div class="card-body">
                              <button style="font-size: 14px" type="button" class="btn btn-primary" data-dismiss="modal" (click)="optionClicked($event, 'crowdSource')">
                                {{ "Settings.tabs.crowdSource" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </mat-tab>

                    <!-- Tracklogs -->
                    <mat-tab *ngIf="currentUser.soultionTiers[0][0].gpS_Track_Logs" title="{{ 'Settings.tabs.gpstrack' | translate }}" label="{{ 'Settings.tabs.gpstrack' | translate }}">
                      <ng-template matTabContent>
                        <app-sms-gpstrack
                          [TimeExtent]="TimeExtent"
                          [SimpleLineSymbol]="SimpleLineSymbol"
                          [SimpleRenderer]="SimpleRenderer"
                          [Color]="Color"
                          [TimeSlider]="TimeSlider"
                          [TimeInfo]="TimeInfo"
                          [map]="map"
                          [registry]="registry"
                          [Popup]="Popup"
                          [domConstruct]="domConstruct"
                        >
                        </app-sms-gpstrack>
                      </ng-template>
                    </mat-tab>

                    <!-- Asset Attributes -->
                    <mat-tab title="{{ 'Settings.tabs.assetattributes' | translate }}" label="{{ 'Settings.tabs.assetattributes' | translate }}">
                      <ng-template matTabContent>
                        <app-sms-asset-attributes 
                          [Query]="Query" 
                          [Graphic]="Graphic" 
                          [FeatureLayer]="FeatureLayer"
                        > 
                        </app-sms-asset-attributes>
                      </ng-template>
                    </mat-tab>

                    <!-- Defaults -->
                    <mat-tab title="{{ 'Settings.tabs.setdefaults' | translate }}" label="{{ 'Settings.tabs.setdefaults' | translate }}">
                      <ng-template matTabContent>
                        <app-sms-set-defaults 
                          [Graphic]="Graphic" 
                          [map]="map" 
                          [FeatureTable]="FeatureTable" 
                          [Query]="Query" 
                          [QueryTask]="QueryTask" 
                          [FeatureLayer]="FeatureLayer"
                        > 
                        </app-sms-set-defaults
                      ></ng-template>
                    </mat-tab>

                    <!-- Bulk Insert -->
                    <mat-tab *ngIf="jcc_functional && currentUser.soultionTiers[0][0].bulk_Insert" title="{{ 'Settings.tabs.bulkinsert' | translate }}" label="{{ 'Settings.tabs.bulkinsert' | translate }}">
                      <ng-template matTabContent>
                        <app-sms-bulkinsert></app-sms-bulkinsert>
                      </ng-template>
                    </mat-tab>

                    <!-- Map Export -->
                    <mat-tab
                      *ngIf="currentUser.soultionTiers[0][0].map_Export && !currentUser.usesExternalDataProvider"
                      title="{{ 'Settings.tabs.mapexport' | translate }}"
                      label="{{ 'Settings.tabs.mapexport' | translate }}">
                      <ng-template matTabContent>
                        <app-sms-map-export 
                          [map]="map" 
                          [Geoprocessor]="Geoprocessor"
                        >
                        </app-sms-map-export>
                      </ng-template>
                    </mat-tab>

                  </mat-tab-group>
                </ng-template>
              </div>
            <!-- </div> -->
          </mat-tab>

          <!-- Mobileye Change Report -->
          <mat-tab *ngIf="jcc_functional && currentUser.soultionTiers[0][0].user_Administration && currentUser.usesExternalDataProvider" label="Change Report">
            <app-change-report [FeatureLayer]="FeatureLayer" [Graphic]="Graphic"></app-change-report>
          </mat-tab>
        </mat-tab-group>
      </section>
    </div>
  </div>
</div>


<!-- <app-modal #modalRootAdmin>
  <ng-container class="app-modal-header">
    <h2 class="mb-1"><b>{{'Administrator.maindiv.header'|translate}}</b></h2>
  </ng-container>
  <ng-container class="app-modal-body" *ngIf="currentUser.rolePermissions.roleName === '3MAdmin'">
    <sms-administrator></sms-administrator>
  </ng-container>
</app-modal> -->

<!-- Administrator (3M Admin) form -->
<div class="modal fade" id="nerModal" tabindex="-1" role="dialog" aria-labelledby="nerModalLabel" aria-hidden="true" data-backdrop="false" #appMovableArea1>
  <div class="modal-dialog" role="document" id="nerModalLabel">
    <div class="modal-content modal-xl adminset" ngResizable [bounds]="appMovableArea1" [inBounds]="inBounds" [rzHandles]="'e,w'" ngDraggable [handle]="DemoHandle1">
      <div class="modal-header" #DemoHandle1>
        <div class="modal-title">
          <h2 class="mb-1">
            <b>{{ "Administrator.maindiv.header" | translate }}</b>
          </h2>
        </div>
        <button type="button" class="close" data-dismiss="modal" (click)="optionClicked($event, 'admin')"><span aria-hidden="true">&times;</span></button>
        <!-- <button type="button" class="close" aria-label="Close" (click)="d('Cross click')"> -->
        <!-- <span aria-hidden="true">&times;</span>
     </button> -->
      </div>
      <div class="modal-body modalHeights show" id="administrationPopup">
        <ng-container class="app-modal-body" *ngIf="currentUser.rolePermissions.roleName === '3MAdmin'">
          <sms-administrator></sms-administrator>
        </ng-container>
      </div>
    </div>
  </div>
</div>
